import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-note-to-approver-card',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './note-to-approver-card.component.html',
  styleUrls: ['./note-to-approver-card.component.scss']
})
export class NoteToApproverCardComponent {
  @Input() isCreateMode = true;
  @Input() noteText = '';
  @Output() noteTextChange = new EventEmitter<string>();

  onNoteChange(val: string): void {
    this.noteText = val;
    this.noteTextChange.emit(val);
  }
}
